import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMagnifierMinus20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMagnifierMinus20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M9.5 1a8.5 8.5 0 0 1 6.516 13.955l2.678 2.679a.75.75 0 0 1-1.061 1.06l-2.678-2.678A8.5 8.5 0 1 1 9.5 1m0 1.5a7 7 0 1 0 0 14 7 7 0 0 0 0-14m2.75 6.25a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5z"
            />
        </svg>
    );
}
export default memo(IconMagnifierMinus20);
